export default "__VITE_ASSET__BYbDM5hf__"